import { Injectable, PLATFORM_ID, inject } from '@angular/core';

import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ProductListArgs } from '../model/product-list-args.model';
import { prediggoTranslation } from '@assets/prediggoObject';
import { SfLocalizeService, SfSiteInfo, SITE_INFO } from '@app/sf-lib/public_api';
import { FacetNotFoundService } from '@app/shared/facet-not-found/facet.not-found.service';
import { isPlatformServer } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class ProductsResolver  {
  private readonly localize = inject(SfLocalizeService);
  private readonly facetNotFound = inject(FacetNotFoundService);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly siteInfo = inject<SfSiteInfo>(SITE_INFO);

  private getKeyByValue(object: Record<string, string>, value: string): string | undefined {
    return Object.keys(object).find(key => object[key] === value);
  }

  private translateSegments(segments: string[]): string[] {
    const rebuildSegments: string[] = [];

    for (let i = 0; i < segments.length; i += 2) {
      rebuildSegments.push(`${segments[i]}/${segments[i + 1]}`);
    }

    const translatedRebuildSegments: string[] = [];
    rebuildSegments.forEach(val => {
      const translation = this.getKeyByValue(prediggoTranslation[this.localize.currentLang.code], val);
      if (translation) {
        translatedRebuildSegments.push(translation.replaceAll("%E9", "é").replaceAll("%20", " "));
      } else {
        if (isPlatformServer(this.platformId)) {
          this.facetNotFound.checkRedirection(this.siteInfo.path);
        }
        translatedRebuildSegments.push(val);
      }
    });

    segments = translatedRebuildSegments.join('/').split('/');
    return segments;
  }

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): ProductListArgs {
    // decode spaces and specials caracters in url
    const url = decodeURI(state.url.split('?')[0]);
    let segments: string[];
    if (this.localize.currentLang.default) {
      // remove the first element => /{routeName}
      segments = url.split('/').slice(2).filter(Boolean);
    } else {
      // Remove the 2 first segment => /{langcode}/{routeName}
      segments = url.split('/').slice(3).filter(Boolean);
    }
    const res = new ProductListArgs();

    // theme is the 2nd element.
    if (segments.length >= 1 && segments.length % 2 === 1) {
      res.themeName = segments.shift();
    }

    // translation
    segments = this.translateSegments(segments).filter(Boolean);

    // fill in facets
    res.facets = {};
    if (segments.length > 1) {
      for (let i = 0; i < segments.length; i+=2) {
        if (res.facets[segments[i]]) {
          (res.facets[segments[i]] as string[]).push(segments[i + 1]);
        } else {
          res.facets[segments[i]] = [segments[i + 1]];
        }
      }
    }
    return res;
  }
}
